import { VariablesService } from '../../../shared/services/variables/variables.service';
import { StorageService } from '../../../shared/services/storage/storage.service';
import { Component, OnInit, ViewChild, ElementRef, Inject, Renderer2, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EventsService } from '../../../shared/services';
import { UtilService } from '../../../shared/services/util/util.service';
import { MatDialog } from '@angular/material/dialog';
// tslint:disable-next-line:max-line-length
import { CommonTalktousModalComponent } from '../../common-talktous-modal/components/common-talktous-modal/common-talktous-modal.component';
import { SignupService } from '../../../shared/services/signup/signup.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-sacflow',
  templateUrl: './sacflow.component.html',
  styleUrls: ['./sacflow.component.scss']
})
export class SacflowComponent implements OnInit {
  @ViewChild('videoPlayer') videoplayer: ElementRef;
  public imgLoader = true;
  isMobile: any;

  constructor(
    public dialog: MatDialog,
    public utilService: UtilService,
    public eventService: EventsService,
    @Inject(DOCUMENT) private document: any,
    private signupService: SignupService,
    private storageService: StorageService,
    private renderer: Renderer2,
    public variablesService: VariablesService,
    public router: Router
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
  }

  playVideo(event) {
    if (this.utilService.isBrowser) {
      const videoPlay = this.videoplayer.nativeElement;
      this.renderer.setStyle(videoPlay, 'display', 'none');
      videoPlay.muted = true;
      if (event.visible === true) {
        this.imgLoader = false;
        videoPlay.play();
        this.renderer.setStyle(videoPlay, 'display', 'block');
      } else {
        videoPlay.pause();
        this.renderer.setStyle(videoPlay, 'display', 'block');
      }
    } else if (event.visible === true) {
      this.imgLoader = true;
    }
  }

  /*Event for start a fundraiser body button */
  pushBodyButton(url) {
    const payload = {
      eventName: 'start_a_campaign_initiated',
      event_type: 'campaign',
      page_name: this.variablesService.pageName || 'home',
      referrer_page: this.document.referrer,
      info_1: 'type',
      info_2: this.variablesService.pageName === 'crowdfunding' ? 'home_5' : 'home_2'
    };
    const full_url = `${this.utilService.domain_details.domain_url}/${url}`;
    this.eventService.sendSystemEvent(payload).subscribe(() => { });
    this.storageService.checkFromSession('sac-initiated', payload);
    this.variablesService.loginType = 'signup';
    this.signupService.startFR(full_url);
  }

  openDialogTalkToUs() {
    const payload = {
      eventName: 'talk_to_us',
      event_type: 'campaign',
      page_name: this.variablesService.pageName || 'home',
      info_1: 'type',
      info_2: 'home_1',
    };
    this.eventService.sendSystemEvent(payload).subscribe(() => { });
    this.dialog.open(CommonTalktousModalComponent, {
      maxWidth: '100vw',
      width: '519px',
      panelClass: 'talk-to-us-modal'
    });
  }

  routeTo(url): void {
    this.router.navigate([url]);
    const payload = {
      eventName: 'medical_cost_calculator',
      event_type: 'campaign',
      info_1: 'step',
      info_2: '1',
      page_name: this.variablesService.pageName || 'home'
    };
    this.eventService.sendSystemEvent(payload).subscribe(_ => _);
  }

}
